import { render, staticRenderFns } from "./distributionCharts.vue?vue&type=template&id=72fb56ba&scoped=true"
import script from "./distributionCharts.vue?vue&type=script&lang=js"
export * from "./distributionCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb56ba",
  null
  
)

export default component.exports